import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { useSettings, waLink, telLink } from "../context/SettingsContext";

export default function MobileStickyCTA() {
  const { settings } = useSettings();
  const msg = `Hello ${settings.company_name || "GNONS Design & Construction"}, I would like to discuss my project.`;
  return (
    <div data-testid="mobile-sticky-cta" className="fixed bottom-0 inset-x-0 z-40 lg:hidden glass border-t border-line safe-bottom">
      <div className="grid grid-cols-2">
        <a href={telLink(settings.phone)} data-testid="sticky-call-btn" className="flex items-center justify-center gap-2 py-4 font-semibold text-ink border-r border-line active:bg-beige">
          <Phone size={18} className="text-gold" /> Call Now
        </a>
        <a href={waLink(settings.whatsapp, msg)} target="_blank" rel="noreferrer" data-testid="sticky-whatsapp-btn" className="flex items-center justify-center gap-2 py-4 font-semibold text-white bg-[#25D366] active:opacity-90">
          <MessageCircle size={18} /> WhatsApp
        </a>
      </div>
    </div>
  );
}
